<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <appSelectOption
      v-for="(option, key) in filteredOptions"
      :key="key"
      :propsData="option"
      :selectId="'options_select_' + key"
      :optionType="optionsType"
    ></appSelectOption>
  </component>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";
import { filter } from "ramda";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getOptions"]),
    ...mapState(useWebproductStore, ["getIsLfp"]),
    optionsType: () => {
      return "main";
    },
    filteredOptions: function () {
      return filter(option => {
        return true;
        return (
          (option.is_popup && parseInt(this.showPopup)) ||
          (!option.is_popup && !parseInt(this.showPopup)) ||
          !this.getIsLfp
        );
      }, this.getOptions);
    }
  },
  props: ["hideContainer", "showPopup"]
};
</script>
